"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "Collection",
  settings: _variables.CollectionItemVariable.settings
}, {
  title: "Checkbox",
  settings: {
    label: {
      type: "var",
      title: "Label",
      description: "Optional text label to add to the checkbox.",
      variableType: "value",
      singleOnly: true
    },
    radio: {
      type: "toggle",
      title: "Radio buttons",
      description: "Show as radio buttons instead of checkboxes."
    },
    checked: {
      type: "toggle",
      title: "Checked by default",
      description: "If the checkbox should be checked by default."
    },
    variable: {
      type: "def",
      title: "Checked Variable",
      description: "Variable to add with the checked status of the checkbox.",
      default: {
        name: "checked"
      }
    }
  }
}];
class CheckboxBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "checkbox");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "item", void 0);
    (0, _defineProperty2.default)(this, "check", void 0);
    (0, _defineProperty2.default)(this, "label", void 0);
    (0, _defineProperty2.default)(this, "radio", void 0);
    (0, _defineProperty2.default)(this, "coll", void 0);
    this.param = param;
    this.check = this.addBlockVariablePair(new _variables.WriteableVariable("value"), param, ["variable", "checked"], {
      key: "variable",
      default: "checked"
    });
    this.check.type.set(!!param.checked);
    let item = variableTypes.get("collection-item");
    item.setReference(this.check.ref);
    this.item = {
      type: item,
      ref: this.addBlockVariable(item, param, ["collection", "value", ["radio", "single"]])
    };
    this.label = this.addBlockVariablePair(variableTypes.get("pointer"), param, [["label", "ref"]]);
    this.radio = this.addBlockVariablePair(variableTypes.get("literal"), param, [["radio", "value"]]);
    this.coll = this.addBlockVariablePair(variableTypes.get("literal"), param, [["collection", "value"]]);
  }
  renderValue() {
    return {
      checked: _variables.vals.truthy(this.check.ref.value()),
      label: _variables.vals.stringValue(this.label.ref.value()),
      radio: _variables.vals.truthy(this.radio.ref.value()),
      collection: _variables.vals.stringValue(this.coll.ref.value())
    };
  }
  setChecked(checked) {
    this.check.type.set(checked);
  }
}
exports.CheckboxBlock = CheckboxBlock;
(0, _defineProperty2.default)(CheckboxBlock, "settings", settings);
//# sourceMappingURL=CheckboxBlock.js.map